import React from 'react';
import Url from 'environment';

const LolViewBan = ({ item }) => {
  // console.log('LolViewBan =', item);
  if (!!item) {
    const { champ } = item;

    return <img src={`${Url.thumb}/0x35${champ.imgPath}`} alt={champ.name} />;
  } else {
    return <img src={`${Url.thumb}/0x25/sports/lol/champ/League-of-Legends-Game-Logo.jpg`} alt={'none pick'} />;
  }
};

export default LolViewBan;
